<template>
    <div>
    
      
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <select
                      class="form-control"
                      id="SelectRegion"
                      required
                      @change="sommeTVA_vidange_service(selectedMois.Month)"
                      v-model="selectedMois.Month"
                    >
                      <option value disabled selected>Mois</option>
                      <option
                        v-for="(annUsers, index) in moezMois"
                        :value="annUsers.id"
                        :key="'i' + index"
                      >
                        {{ annUsers.text }}
                      </option>
                    </select>
                  </div>
                </div>
  
                <div class="col">
                  <div class="form-group">
                    <select
                      class="form-control"
                      id="SelectRegion"
                      required
                      @change="sommeTVA_vidange_service(selectedClient.year)"
                      v-model="selectedClient.year"
                    >
                      <option value disabled selected>Année</option>
                      <option
                        v-for="(annUsers, index) in moezAnnee"
                        :value="annUsers.id"
                        :key="'i' + index"
                      >
                        {{ annUsers.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <b-button variant="info" style="font-size: 15px">
                  Total SUM :
                 {{ addCommasSomme }}
                </b-button>
               
                <b-button variant="success" style="font-size: 15px">
                  Total TVA :
                 {{ addCommasTVA }}
                </b-button>
                <b-button variant="warning" style="font-size: 15px">
                  Total TTC :
                 {{ addCommasTTC }}
                </b-button>
  
                <hr>

Consulter Tous les autres Statistiques
<hr>

<div class="row">
    <div class="col">
      <div class="form-group">
        <!--  <label>Societé *</label> -->
        <select
          class="form-control"
          id="SelectRegion"
          required
          v-model="selected_societe"
        >
          <option value disabled selected>Tous les autres Societé</option>
          <option
            v-for="(annUsers, index) in all_societe"
            :value="annUsers.id"
            :key="'i' + index"
          >
            {{ annUsers.nom }}
          </option>
        </select>
      </div>
    </div>
  </div>
<div class="row">
<div class="col">
    <router-link
:to="{
name: 'Somme-TVA',
params: { id: selected_societe },
}"
>
<CButton
style="font-size: 15px"
color="danger"
class="mr-1 cl"
>
Voir Les statistiques
</CButton>
</router-link>
  </div>
</div>
              <!-- <div class="row">
                <div class="col">
                  <div class="form-group">
                    <input
                      class="form-control personalise"
                      placeholder="Recherche ..."
                      type="text"
                      v-model="search"
                    />
                  </div>
                </div>
              </div> -->
  
              
            </div>
       
      
  </template>
  
  
  <script>
  import { apiDomain } from "../../config";
  import axios from "axios";
  import _ from "lodash";
  export default {
    props: {
      tableHeaderColor: {
        type: String,
        default: "",
      },
    },
    components: {},
    data() {
      return {
        all_societe: [],
      selected_societe: "1",
        count_service:'',
        listes_service: [],
        selected: [],
        get_societe_id_mise: {},
        verif: false,
        selectedOptionId: "",
        moezMois: [
          { id: 1, text: "Janvier" },
          { id: 2, text: "Février" },
  
          { id: 3, text: "Mars" },
          { id: 4, text: "Avril" },
          { id: 5, text: "Mai" },
          { id: 6, text: "Juin" },
  
          { id: 7, text: "Juillet" },
          { id: 8, text: "Août" },
  
          { id: 9, text: "Septembre" },
          { id: 10, text: "Octobre" },
          { id: 11, text: "Novembre" },
          { id: 12, text: "Décembre" },
        ],
        moezAnnee: [
         
          { id: 2022, text: "2022" },
  
          { id: 2023, text: "2023" },
          { id: 2024, text: "2024" },
          { id: 2025, text: "2025" },
          { id: 2026, text: "2026" },
  
          { id: 2027, text: "2027" },
          { id: 2028, text: "2028" },
        ],
        anneeUsers: [2020, 2021, 2022, 2024],
        moisUsers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  
        yearSystem: new Date().getFullYear(),
        moisSystem: new Date().getMonth() + 1,
        selectedMois: {
          Month: new Date().getMonth() + 1,
        },
  
        selectedClient: {
          year: new Date().getFullYear(),
        },
        count_vidange: [],
        selected: [],
        q: "",
        /* ************************** */
  
        idsImprimer: [],
        get_societe: [],
        id_societe: this.$route.params.id,
        select: "",
        all_select: false,
      };
    },
  
    created() {
      this.sommeTVA_vidange_service();
    this.get_societe_services();

    },
  
    computed: {
     
       
      monthDateSystem() {
        if (this.selectedMois.Month < 10) {
          return "0" + this.selectedMois.Month;
        } else {
          return this.selectedMois.Month;
        }
      },
      sommeTTCServiceVidangeOkba () {
      const vidange = this.count_vidange;
        const service = this.count_service;
    const totalVidangeService = Number(service) +  Number(vidange);
    const totalVidangeServiceTVA = totalVidangeService * Number(0.19)  ;
        return Number(totalVidangeService)  +  Number(totalVidangeServiceTVA)  ;
      },

      sommeServiceVidangeOkba () {
      const vidange = this.count_vidange;
        const service = this.count_service;
    const totalVidangeService = Number(service) +  Number(vidange);
       return totalVidangeService;
      },


      TVAServiceVidangeOkba () {
      
       return (this.sommeTTCServiceVidangeOkba)  -  this.sommeServiceVidangeOkba  ;
       
      },

       addCommasTTC() {
  // Convert the number to a string

   // Convert the number to a string
   let numberStr = this.sommeTTCServiceVidangeOkba.toString();
  // Split the string into groups of three characters from the right
  let groups = [];
  while (numberStr.length > 3) {
    groups.unshift(numberStr.slice(-3));
    numberStr = numberStr.slice(0, -3);
  }
  groups.unshift(numberStr);
  // Join the groups with commas and return the result
  return groups.join(",");
},

addCommasSomme() {
  // Convert the number to a string

   // Convert the number to a string
   let numberStr = this.sommeServiceVidangeOkba.toString();
  // Split the string into groups of three characters from the right
  let groups = [];
  while (numberStr.length > 3) {
    groups.unshift(numberStr.slice(-3));
    numberStr = numberStr.slice(0, -3);
  }
  groups.unshift(numberStr);
  // Join the groups with commas and return the result
  return groups.join(",");
},

addCommasTVA() {
  // Convert the number to a string

   // Convert the number to a string
   let numberStr = this.TVAServiceVidangeOkba.toString();
  // Split the string into groups of three characters from the right
  let groups = [];
  while (numberStr.length > 3) {
    groups.unshift(numberStr.slice(-3));
    numberStr = numberStr.slice(0, -3);
  }
  groups.unshift(numberStr);
  // Join the groups with commas and return the result
  return groups.join(",");
},


     
    },
  
    methods: {
      get_societe_services() {
      axios
        .get(`${apiDomain}/api/all_societe`)

        .then((res) => {
          this.all_societe = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },
      sommeTVA_vidange_service() {
        axios
          .get(
            `${apiDomain}/api/sumTVAMonthVidangeSericeSociete/${this.$route.params.id}/${this.monthDateSystem}/${this.selectedClient.year}`
          )
          .then((response) => {
            if(response.data.service[0].total !=null){
              this.count_service = response.data.service[0].total;
            }

            if(response.data.service[0].total == null){
              this.count_service = "0";
            }
            
            if(response.data.vidange[0].total !=null){
              this.count_vidange = response.data.vidange[0].total;
            }
            if(response.data.vidange[0].total ==null){
              this.count_vidange = "0";
            }
            

          })
          .catch(function (error) {
            console.log(error);
          });
      },

  
    
    },
  };
  </script>
  
  <style>
  .feed {
    background: #fff;
    height: 106px;
    overflow: scroll;
  }
  .btdelete {
    padding: 11px 27px !important;
    margin-top: 38px;
    border-radius: 5px;
  }
  /* 
  .md-card img {
    width: 55% !important;
    height: auto;
  } */
  
  .non_paye {
    position: absolute;
    background: #f10735;
    opacity: 0.8;
    display: inline-block;
    padding: 0 10px;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    z-index: 1;
    margin-left: -1.4%;
    /* margin-top: -15.6%; */
    margin-top: 1.4% !important;
    height: 34px;
    line-height: 9px;
    border-radius: 15px;
  }
  
  .paye {
    position: absolute;
    background: #28e40c;
    opacity: 0.8;
    display: inline-block;
    padding: 0 10px;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    z-index: 1;
    margin-left: -1.4%;
    margin-top: -16.6% !important;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }
  
  .en_attente {
    position: absolute;
    background: #c37600;
    opacity: 0.8;
    display: inline-block;
    padding: 0 10px;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    z-index: 1;
    margin-left: -1.4%;
    /*   margin-top: -15.6%; */
  
    margin-top: -16.6% !important;
  
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }
  
  nav {
    display: flex;
    justify-content: center;
  }
  
  .pagination {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
  }
  
  .pagination li {
    margin: 0 1px;
    padding: 11px 6px !important;
    text-decoration: none;
  }
  
  .pagination > .active > a,
  .pagination > .active > a:focus,
  .pagination > .active > a:hover,
  .pagination > .active > span,
  .pagination > .active > span:focus,
  .pagination > .active > span:hover {
    background-color: #2a357d !important;
  
    color: #ffffff !important;
    -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
      0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
    box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
      0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  }
  
  .pagination > li > a,
  .pagination > li > span {
    color: fff;
    list-style-type: cercle;
    border: 0;
    border-radius: -16px !important;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    padding: 9px;
    margin: 0 3px;
    min-width: 31px;
    height: 31px;
    line-height: 30px;
    color: #999999;
    font-weight: 400;
    font-size: 11px;
    text-transform: uppercase;
    background: transparent;
    /* border-color: blue !important; */
    border-radius: 4px;
    background-color: #e88e08 !important;
    /* border-color: #000; */
    color: #fff !important;
  }
  
  .index {
    display: inline-block;
    height: 36px;
    width: 36px;
    line-height: 36px;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    background-color: #e88e08;
    border-radius: 50% !important;
    text-align: center;
    position: relative;
    z-index: 2;
  }
  
  .cer {
    color: rgb(255, 255, 255);
    width: 30px;
    height: 30px;
    line-height: -10px;
    border-radius: 50%;
    font-size: 50px;
    text-align: center;
    background: rgb(245 175 19);
  }
  .cer_green {
    color: rgb(255, 255, 255);
    width: 30px;
    height: 30px;
    line-height: -10px;
    border-radius: 50%;
    font-size: 50px;
    text-align: center;
    background: #0ef717;
  }
  </style>
  
  